<template>
    <div class="content_div">
        <el-card>
            <!--商品-->
            <el-form :inline="true" :model="query" class="demo-form-inline" STYLE="margin-bottom: 20px;">
                <!--类型：1员工餐2客户餐-->
                <el-form-item label="订单类型">
                    <el-select class="input_class" v-model="query.type" placeholder="请选择订单类型">
                        <el-option label="员工餐" :value=1></el-option>
                        <el-option label="客户餐" :value=2></el-option>
                    </el-select>
                </el-form-item>
                <!--下单时间，年月日-->
                <el-form-item label="预约时间">
                    <el-date-picker
                        class="input_class"
                        v-model="query.month"
                        type="month"
                        placeholder="请选择年月"
                        value-format="yyyy-MM">
                    </el-date-picker>
                </el-form-item>

                <!--订单状态：1已下单；4已完成-->
                <el-form-item label="订单状态">
                    <el-select multiple="true" class="input_class" v-model="query.stateArr" placeholder="请选择订单状态">
                        <el-option label="已下单" :value=1></el-option>
                        <el-option label="已完成" :value=4></el-option>
                    </el-select>
                </el-form-item>

                <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
                <!--导出-->
                <el-button type="info" icon="el-icon-download" @click="exportExcel">导出月度部门明细</el-button>
                <br>
                <el-button type="primary" icon="el-icon-download" @click="exportExcel2(1)">导出月度员工明细-早餐</el-button>
                <el-button type="warning" icon="el-icon-download" @click="exportExcel2(2)">导出月度员工明细-午餐</el-button>
                <el-button type="success" icon="el-icon-download" @click="exportExcel2(3)">导出月度员工明细-晚餐</el-button>
            </el-form>

            <el-table
                :data="list"
                show-summary
                :max-height="700"
                border>
                <el-table-column type="index" label="编号" width="120"/>
                <el-table-column prop="month" label="统计月份" width="150"/>
                <el-table-column prop="deptName" label="所属部门" width="180"/>
                <!-- 合并表头示例 -->
                <el-table-column :label="(query.type===1?'员工餐':'客户餐')+'-早餐'" :colspan="2" align="center">
                    <el-table-column prop="breakfastCount" label="份数" width="120" align="center"/>
                    <el-table-column prop="breakfastAmount" label="金额" width="120" align="center"/>
                </el-table-column>

                <el-table-column :label="(query.type===1?'员工餐':'客户餐')+'-午餐'" :colspan="2" align="center">
                    <el-table-column prop="lunchCount" label="份数" width="120" align="center"/>
                    <el-table-column prop="lunchAmount" label="金额" width="120" align="center"/>
                </el-table-column>

                <el-table-column :label="(query.type===1?'员工餐':'客户餐')+'-晚餐'" :colspan="2" align="center">
                    <el-table-column prop="dinnerCount" label="份数" width="120" align="center"/>
                    <el-table-column prop="dinnerAmount" label="金额" width="120" align="center"/>
                </el-table-column>

                <!-- 添加总计列 -->
                <el-table-column label="总计" :colspan="2" align="center">
                    <el-table-column prop="totalCount" label="总份数" width="120" align="center"/>
                    <el-table-column prop="totalAmount" label="总金额" width="120" align="center"/>
                </el-table-column>
                <!--                <el-table-column align="center" label="操作" v-if="query.type===1" width="180">-->
                <!--                    <template slot-scope="scope">-->
                <!--                        <el-button size="small" icon="el-icon-download" type="danger" @click="btnExportEmployee(2,scope.row.deptId)">午餐</el-button>-->
                <!--                        <el-button size="small" icon="el-icon-download" type="success" @click="btnExportEmployee(3,scope.row.deptId)">晚餐</el-button>-->
                <!--                    </template>-->
                <!--                </el-table-column>-->
            </el-table>
        </el-card>
    </div>
</template>
<script>

import {exportDeptEmployeeDetailOrder, exportDeptOrder, reqListDeptOrder} from "../../../api/core/Order";

export default {
    name: "ShopOrder",
    async created() {
        this.query.type = 1;
        this.query.month = new Date().getFullYear() + "-" + (new Date().getMonth() + 1);
        const monthStr = this.query.month.replace(
            /^(\d{4})-(\d)$/,
            (_, y, m) => `${y}-${m.padStart(2, '0')}`
        );
        this.query.month = monthStr;
        await this.load();
    },
    data() {
        return {
            query: {
                month: null,
                type: null,
                stateArr:[4],
            },
            list: [],
            total: 0,
            shopList: [],
        }
    },
    methods: {
        async load() {
            if (!this.query.type) {
                this.$message.error("请选择订单类型！");
                return;
            }
            const monthStr = this.query.month.replace(
                /^(\d{4})-(\d)$/,
                (_, y, m) => `${y}-${m.padStart(2, '0')}`
            );
            this.query.month = monthStr;
            this.list = [];
            if (this.query.stateArr){
                //数组转List
                this.query.stateList = this.query.stateArr.join(",");
            }else{
                this.query.stateList = [];
            }
            let data = await reqListDeptOrder(this.query);
            // 为每条数据添加总计字段
            data.forEach(item => {
                item.totalCount = (item.breakfastCount || 0) + (item.lunchCount || 0) + (item.dinnerCount || 0);
                item.totalAmount = (item.breakfastAmount || 0) + (item.lunchAmount || 0) + (item.dinnerAmount || 0);
            });
            this.list = data;
        },
        async exportExcel() {
            const monthStr = this.query.month.replace(
                /^(\d{4})-(\d)$/,
                (_, y, m) => `${y}-${m.padStart(2, '0')}`
            );
            this.query.month = monthStr;
            if (this.query.stateArr){
                //数组转List
                this.query.stateList = this.query.stateArr.join(",");
            }else{
                this.query.stateList = [];
            }
            await exportDeptOrder(this.query)
                .then(res => {
                    // 创建临时链接并自动下载
                    const blob = new Blob([res], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    })
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = url
                    a.download = `月度订单导出.xlsx`
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                    window.URL.revokeObjectURL(url)
                    this.$message.success('导出成功')
                })
                .finally(() => {
                })
        },
        async exportExcel2(type) {
            this.query.type = type;
            await exportDeptEmployeeDetailOrder(this.query).then(res => {
                // 创建临时链接并自动下载
                const blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                })
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `部门月度订单明细.xlsx`
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                window.URL.revokeObjectURL(url)
                this.$message.success('导出成功')
            }).finally(() => {
            })
        },
        async btnExportEmployee(type, deptId) {

            this.query.deptId = deptId;

        }
    }
}
</script>
